import defaultState from './defaultState'
import { ReduxAction } from '../../reducerType'
import { SyncUIReducer } from './types'
import { syncUiType } from '../../../actions/docs/syncUi/syncUiTypes'

export default function (state: SyncUIReducer = defaultState, { type, payload }: ReduxAction): SyncUIReducer {

  switch (type) {

    case syncUiType.SET_SYNC_ENDING_LIVE:
      return { ...state, endingLive: payload }
    case syncUiType.SET_SYNC_FOCUS_ON:
      return { ...state, focusOn: payload }
      case syncUiType.SET_SYNC_SCREENSHARE_FOCUS:
        return { ...state, screenShareFocus: payload }
    case syncUiType.SET_SYNC_DOMINANT_SPEAKER:
        return { ...state, dominantSpeaker: payload }
    case syncUiType.SET_SYNC_GIG_TERMINATION_TIME:
      return { ...state, gigTerminationTime: payload }
    case syncUiType.SET_SYNC_GOING_LIVE:
      return { ...state, goingLive: payload }
    case syncUiType.SET_SYNC_LIVE_DATE_TIME:
      return { ...state, liveDateTime: payload }
    case syncUiType.SET_SYNC_LIVE_ENDED:
      return { ...state, liveEnded: payload }
    case syncUiType.SET_SYNC_MEDIA_TYPE:
      return { ...state, mediaType: payload }
    case syncUiType.SET_SYNC_MUTE:
      return { ...state, mute: payload }
    case syncUiType.SET_SYNC_PLAYIN_MUTE:
      return { ...state, playInMute: payload }
    case syncUiType.SET_SYNC_PARTICIPANT_INFORMATION:
      return { ...state, participantInformation: payload }
    case syncUiType.SET_SYNC_PRESENTER_COUNT:
      return { ...state, presenterCount: payload }
    case syncUiType.SET_SYNC_VIDEO_DISPLAY:
      return { ...state, videoDisplay: payload }
    case syncUiType.SET_SYNC_SLIDE_POSITION:
      return { ...state, slidePosition: payload }
    case syncUiType.SET_SYNC_PENDING_SLIDES_ID:
      return { ...state, pendingSlidesId: payload }
    case syncUiType.SET_SYNC_AUTO_SPOTLIGHT:
      return { ...state, autoSpotlight: payload }
    case syncUiType.SET_SYNC_EVENT_STREAM_URL:
      return { ...state, eventStreamUrl: payload }
    case syncUiType.SET_SYNC_LAYOUTS:
      return { ...state, layouts: payload }
    case syncUiType.SET_SYNC_QUESTIONS:
      return { ...state, questions: payload }
    case syncUiType.SET_SYNC_CONVERSATION_CREATOR_ID:
      return { ...state, conversationCreatorId: payload }
    case syncUiType.SET_SYNC_CONVERSATION_NAME:
      return { ...state, conversationName: payload }
    default:
      return state

  }

}
